import { render, staticRenderFns } from "./HistoryTrend.vue?vue&type=template&id=742b78b5&"
import script from "./HistoryTrend.vue?vue&type=script&lang=ts&"
export * from "./HistoryTrend.vue?vue&type=script&lang=ts&"
import style0 from "./HistoryTrend.vue?vue&type=style&index=0&id=742b78b5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports